import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import { HttpResponse, QuoMessageResponse } from "@/types";

export function useGetQuoMessages({ talentId }: { talentId: number | null }) {
  return useQuery({
    queryKey: ["quo-messages", talentId],
    refetchInterval: 10_000,
    queryFn: async () => {
      const queryParams = misc.prepareQueryParams({ talentId });

      // Need to query with talentId.
      if (queryParams.toString() === "") return [];

      const path = `quo-messages?${queryParams.toString()}`;
      const res = await guacHttpClient.get<
        QuoMessageResponse[],
        HttpResponse<QuoMessageResponse[]>
      >(path);
      return res.data;
    },
  });
}
